// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__22xfJ","title":"AfterFrontImage_title__1AZoq"};